export const getHrMin = (time?: string | null) => {
  const splittedTime = time ? time.split(":") : null
  return splittedTime
    ? { hr: splittedTime[0], min: splittedTime[1] }
    : { hr: null, min: null }
}
